
import ContactSection from "./components/ContactSection.vue";
import IndustryGrowthStatement from "./components/IndustryGrowthStatement.vue";
import {
  flatTreeData,
  findParentElements,
  getBreadList,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const menus = store.state.menu.filter(m => m.type === "contact");

    const path = `/${route.path.split("/")[1]}`;
    const currentVO = app.$websiteDataHelper.getCurrentVO(menus, path);

    const flatArray = flatTreeData(menus);
    const breadList = findParentElements(route.meta[0].nodeid, flatArray);
    return {
      banner: currentVO?.bannerurl || "/img/knowledge-page-banner.png",
      title: (currentVO.name_ch || "news").toUpperCase().replace(/-/g, " "),
      contactShare: store.state.wmkcData.contactShare || {},
      baseInfo: store.state.baseInfo || {},
      breadList,
      currentVO,
    };
  },
  head() {
    const { path, meta } = this.$route;
    const { menu, baseJsonLd } = this.$store.state.jsonLd;
    const siteUrl = baseJsonLd.url;
    const breadList = getBreadList(menu, this.currentVO, 1);

    const jsonld = {
      ...baseJsonLd,
      name: meta?.title,
      description: meta?.description,
      keywords: meta?.keywords,
      url: new URL(path, siteUrl).toString(),
    };

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            jsonld,
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadList,
            },
          ],
        },
      ],
    };
  },
  components: { ContactSection, IndustryGrowthStatement },
};
